import React from 'react';
import { observer } from 'mobx-react';

import { Divider } from 'ui';

import FileItem from './FileItem';

interface Props {
  files?: UUIDField[];
  onRemove: (id: UUIDField) => void;
  classNames?: (classes: string[]) => string[];
}

function FileList({ files, onRemove, classNames = (a) => a }: Props) {
  if (files === undefined || files.length === 0) {
    return null;
  }

  return (
    <div className={classNames(['space-y-2']).join(' ')}>
      {files.map((fileUploadId, fileUploadIndex) => (
        <div key={fileUploadId}>
          <FileItem fileUploadId={fileUploadId} onRemove={() => onRemove(fileUploadId)} />
          {files.length > 1 && fileUploadIndex !== files.length - 1 && <Divider />}
        </div>
      ))}
    </div>
  );
}

export default observer(FileList);
